import validationProcessor from './core/validationProcessor';

export { default as parseValidators } from './core/parseValidators';
export { default as validators } from './core/validators';
export type { IValidators as Validators, IValidators } from './core/validators';
export { default as FormContext, withFormContext } from './FormContext';
export { default as FormContextProvider, withFormProvider } from './FormContextProvider';
export { default as FormSection } from './sections/FormSection';
export { default as ListFormSection } from './sections/ListFormSection';
export { default as withValidation } from './withValidation';
export { default as defaultStrings } from './locale/defaultStrings_en_US';
// eslint-disable-next-line camelcase
export { default as defaultStrings_en_US } from './locale/defaultStrings_en_US';
export { default as useValidation } from './useValidation';
export { useInputAPI, withInputAPI } from './inputAPI';

export { validationProcessor };

// These settings are defaults and can be overridden via setConfig() below.
const defaultConfig = {
  /* Should we only allow 1 error per validation run? True we stop after the first error,
   * false we accumulate errors. */
  stopOnFirstError: true,
};

// use this if you need to change the config for the entire app
export function setConfig(newConfig: { stopOnFirstError: boolean }) {
  validationProcessor.setConfig(newConfig);
}

setConfig(defaultConfig);
